import { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";

export type ActivityEvent = "LOGIN" | "LOGIN_FALHOU" | "ACESSO" | "ALTERACAO";

export type ActivityLog = {
  id: number;
  createdAt: string;
  event: ActivityEvent;
  userId: number | null;
  userName: string | null;
  userEmail: string | null;
  userRole: string | null;
  description: string | null;
  method: string | null;
  path: string | null;
  status: number | null;
  profileRef: string | null;
  profileName: string | null;
  targetUserId: number | null;
  targetUserName: string | null;
  targetUserEmail: string | null;
  ip: string | null;
  userAgent: string | null;
  /** Primeira vez que este usuário aparece com este IP. */
  ipNovo: boolean;
};

export type ActivityPage = {
  items: ActivityLog[];
  total: number;
  page: number;
  size: number;
};

export type VariosLugares = {
  userId: number;
  userName: string | null;
  userEmail: string | null;
  userRole: string | null;
  ips: number;
  aparelhos: number;
  listaIps: string | null;
  ultimo: string | null;
};

export type ActivitySummary = {
  horas: number;
  kpis: { logins: number; falhas: number; alteracoes: number; usuarios: number; ips: number };
  variosLugares: VariosLugares[];
};

export type ActivityQuery = {
  de?: string;
  ate?: string;
  userId?: number;
  event?: string;
  q?: string;
  ip?: string;
  /** 0-based, como o backend. */
  page: number;
  size: number;
};

const auth = (token: string, params?: object): AxiosRequestConfig => ({
  headers: { Authorization: `Bearer ${token}` },
  params,
});

const listar = async (query: ActivityQuery, token: string): Promise<ActivityPage | null> => {
  try {
    const result = await ApiService.get("/admin/activity-logs", auth(token, query));
    return result.data?.data ?? null;
  } catch (error) {
    toast.error(handleError(error, "Não foi possível carregar os logs.").message);
    return null;
  }
};

const resumo = async (horas: number, token: string): Promise<ActivitySummary | null> => {
  try {
    const result = await ApiService.get("/admin/activity-logs/summary", auth(token, { horas }));
    return result.data?.data ?? null;
  } catch (error) {
    toast.error(handleError(error, "Não foi possível carregar o resumo dos logs.").message);
    return null;
  }
};

export const ActivityLogsService = { listar, resumo };
